import type { IAnalytics } from "../../dashboard/types";

export type MetricaExtra = {
  chave: "bookings" | "foodMenuClicks" | "minisiteWhatsappClicks";
  rotulo: string;
  valor: number;
  origem: string;
};

/**
 * Métricas que só aparecem quando fazem sentido para a empresa.
 * Reservas e cardápio (Google): só com total > 0 no período — quase nenhuma
 * ficha tem, e um "0" para oficina mecânica só confunde.
 * WhatsApp do mini-site (contado por nós, não pelo Google): aparece para quem
 * tem mini-site, mesmo zerado; null = perfil sem mini-site.
 */
export const metricasExtras = (analytics: Partial<IAnalytics> | null | undefined): MetricaExtra[] => {
  if (!analytics) return [];
  const extras: MetricaExtra[] = [];
  if ((analytics.bookings ?? 0) > 0) {
    extras.push({ chave: "bookings", rotulo: "Reservas pela ficha", valor: analytics.bookings ?? 0, origem: "Dados do Google" });
  }
  if ((analytics.foodMenuClicks ?? 0) > 0) {
    extras.push({ chave: "foodMenuClicks", rotulo: "Cliques no cardápio", valor: analytics.foodMenuClicks ?? 0, origem: "Dados do Google" });
  }
  if (typeof analytics.minisiteWhatsappClicks === "number") {
    extras.push({
      chave: "minisiteWhatsappClicks",
      rotulo: "Cliques no WhatsApp",
      valor: analytics.minisiteWhatsappClicks,
      origem: "pelo mini-site",
    });
  }
  return extras;
};
